import { Condition as ModelCondition } from "@redotech/redo-model/return-flow/condition";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export type OrderNumberState = readonly string[];

export const ORDER_NUMBER = (
  Details: React.ComponentType<ConditionTypeDetailsProps<OrderNumberState>>,
): ConditionType<OrderNumberState, ModelCondition.OrderNumber> => ({
  name: "Order number",
  description(state) {
    return `Order numbers: ${state.join(", ")}`;
  },
  Details(props: ConditionTypeDetailsProps<OrderNumberState>) {
    return React.createElement(Details, props);
  },
  empty: [],
  fromModel(model) {
    return model.orderNumbers;
  },
  toModel(state) {
    return { type: ModelCondition.ORDER_NUMBER, orderNumbers: state };
  },
  valid() {
    return true;
  },
});
